export const FIELD_ABR_BASE_PATH = 'field/abr';
